export type SidebarNavItem = {
  id: string;
  title: string;
  path: string;
  subNav?: SidebarNavItem[];
  role: string;
};

export const sidebarNavItems: SidebarNavItem[] = [
  {
    id: '1',
    title: 'ROOM一覧',
    path: '/admin/room',
    role: 'all',
  },
  {
    id: '2',
    title: 'マスタテンプレート',
    path: '/masterTemplate',
    role: 'all',
    subNav: [
      {
        id: '2-1',
        title: 'ラベルセット',
        path: '/admin/labelset',
        role: 'all',
      },
      {
        id: '2-2',
        title: 'メニュー資料',
        path: '/admin/material',
        role: 'all',
      },
      {
        id: '2-3',
        title: 'メニューセット',
        path: '/admin/menuset',
        role: 'all',
      },
    ],
  },
  {
    id: '3',
    title: '顧客一覧',
    path: '/admin/customer',
    role: 'all',
  },
  {
    id: '4',
    title: '営業一覧',
    path: '/admin/salesman',
    role: 'all',
  },
  {
    id: '5',
    title: '管理者一覧',
    path: '/admin/admin',
    role: 'admin',
  }
];